import React, { Component } from 'react';
import classNames from 'classnames';
import './styles.scss';

import { connect } from 'react-redux';

interface InnerWrapperProps {
  theme?: string;
  noMarginBtm?: boolean;
  children?: any;
}

class InnerWrapper extends Component<InnerWrapperProps> {
  componentDidMount() {}

  render() {
    const { theme, noMarginBtm } = this.props;
    const InnerWrapperMainClasses = classNames({
      'inner-wrapper': true,
      'inner-wrapper--blue': theme === 'blue',
      'inner-wrapper--no-margin-btm': noMarginBtm == true,
    });
    return <div className={InnerWrapperMainClasses}>{this.props.children}</div>;
  }
}

export default connect()(InnerWrapper);
